import Badge from "@/v2-backoffice-client/components/badge"
import {
  APP_CODES,
  formatAppCode,
  getAppCodeColor,
} from "@/v2-backoffice-client/usage/usage.constants"

export type UsageProductChipsProps = {
  /** App codes with activity in the window; rendered in catalogue order. */
  apps: string[]
  className?: string
}

/**
 * The products a scope's tracked activity comes from, as a line of chips:
 * the tag that says "this is Placepoint MCP usage" when a customer or a
 * person lives in one product only, and which products share the work when
 * there are several. The dot colours match the product-mix bar.
 */
function UsageProductChips(props: UsageProductChipsProps) {
  const { apps, className } = props
  const present = new Set(apps)
  const ordered = [
    ...APP_CODES.filter((app) => present.has(app)),
    ...apps.filter((app) => !APP_CODES.includes(app)),
  ]

  if (ordered.length === 0) return null

  return (
    <div className={className}>
      <span className="mr-1 text-xs text-muted-foreground">
        {ordered.length === 1 ? "Product in use" : "Products in use"}
      </span>
      <span className="usage-report-chips inline-flex">
        {ordered.map((app) => (
          <Badge
            key={app}
            variant="outline"
            size="sm"
            className="gap-1.5 font-normal"
          >
            <span
              aria-hidden
              className="size-1.5 rounded-full"
              style={{ backgroundColor: getAppCodeColor(app) }}
            />
            {formatAppCode(app)}
          </Badge>
        ))}
      </span>
    </div>
  )
}

export default UsageProductChips
